module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', _vm._g(_vm._b({
    staticClass: "StepCard",
    class: {
      'Active': _vm.isActive
    },
    attrs: {
      "ripple": false
    }
  }, 'v-card', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "TopLabel pr-4 pt-3"
  }, [_c('p', {
    staticClass: "caption font-weight-light font-italic"
  }, [_vm._v(_vm._s(_vm.topLabel || ''))]), _vm._v(" "), (_vm.deleteBtn) ? _c('v-btn', {
    staticClass: "delete-btn",
    attrs: {
      "icon": "",
      "color": "pink"
    },
    on: {
      "click": _vm.deleteBtnHandler
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#F93A2F"
    }
  }, [_vm._v("delete_outline")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.img || _vm.title || _vm.subtitle) ? _c('v-card-title', [(_vm.img) ? _c('v-avatar', {
    staticClass: "mr-4",
    attrs: {
      "size": "52"
    }
  }, [_c('img', {
    attrs: {
      "alt": _vm.altImg || '',
      "src": _vm.img
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pt-2 text-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.title || ''))]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "pa-0"
  }, [_vm._v(_vm._s(_vm.subtitle || ''))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "py-4 pl-6 pr-4"
  }, [_c('v-col', {
    staticClass: "pa-0 text-left flex-grow-1"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 flex-shrink-1 flex-grow-0 d-flex align-end"
  }, [_c('span', {
    staticClass: "caption font-weight-light font-italic"
  }, [_vm._v(_vm._s(_vm.bottomLabel || ''))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac5af2d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/StepCard.vue
// module id = 1741
// module chunks = 0